import {
  and,
  ControlProps,
  RankedTester,
  rankWith,
  schemaMatches,
} from "@jsonforms/core";
import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import { TextField } from "@mui/material";
import { ChangeEvent } from "react";
import { formatPhoneNumberInput } from "hhn-commons";
import { CountryCode } from "@home-health-notify/domain";

const PhoneNumberRenderer = ({
  path,
  data,
  handleChange,
  uischema,
  schema,
  errors,
  required,
  enabled,
}: ControlProps) => {
  const { label, options } = uischema;
  const ctx = useJsonForms();
  const rootData = ctx.core?.data;

  // Get country code from options or from form data
  const countryCodePath = options?.countryCodePath;
  let countryCode = CountryCode.US; // default

  // If countryCodePath is provided in options, use it to get value from form data
  if (countryCodePath && rootData) {
    const parts = countryCodePath.split(".");
    let current: any = rootData;
    for (const part of parts) {
      current = current?.[part];
    }
    if (current) {
      countryCode = current;
    }
  }

  const handlePhoneChange = (event: ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    // Remove all non-digit characters for storage
    const cleanedNumber = input.replace(/\D/g, "");
    handleChange(path, cleanedNumber !== "" ? cleanedNumber : undefined);
  };

  const maxLength = countryCode === CountryCode.US ? 14 : 10;

  return (
    <TextField
      disabled={!enabled}
      required={required}
      label={label?.toString() || schema.title}
      value={formatPhoneNumberInput(data || "", countryCode)}
      type="tel"
      onChange={handlePhoneChange}
      error={!!errors}
      helperText={errors || ""}
      sx={{
        mb: 0.75,
        width: "100%",
      }}
      slotProps={{
        htmlInput: {
          maxLength,
        },
      }}
    />
  );
};

// Tester: matches string fields with maxLength of 10 (phone/fax numbers)
export const phoneNumberTester: RankedTester = rankWith(
  6,
  and(
    schemaMatches(schema => {
      return schema.type === "string" && schema.maxLength === 10;
    }),
  ),
);

export default withJsonFormsControlProps(PhoneNumberRenderer);
